<template>
  <div
    class="service-item-container normal-button"
    v-bind:class="{active: isSelected, left: index % 2 == 0, right: index % 2 != 0}"
    @click="onClick"
  >
    <span class="title" v-bind:class="{'title-active': isSelected}">{{title}}</span>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      isRequired: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    index: {
      type: Number,
      isRequired: true
    }
  },
  methods: {
    onClick() {
      this.$emit("onItemClick");
    }
  }
};
</script>

<style lang="scss" scoped>
.active {
  background-color: #2e2323;
  border: none;
}
.title-active {
  color: white;
}
.title {
  font-family: "SFUIText-Medium", -apple-system;
  font-weight: 500;
  font-size: 16px;
}
.left {
  margin-right: 7.5px;
}
.right {
  margin-left: 7.5px;
}
.service-item-container {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
  padding: 15px;
  border: 1.5px solid #eeeeee;
  border-radius: 6px;
  width: calc(50% - 7.5px);
  .icon {
    height: 25px;
    width: auto;
    margin-left: 15px;
  }
}
</style>